import BASE_API from '@/api/dataBase.js';
import COM_API from '@/api/masterData/company.js';
// import { yesNoList } from '@/constants';
export const fromColumns = (ctx) => {
  let searchCompanyCode = ctx.query.contractBusinessCompanyNo;
  let searchDepartmentCode = ctx.query.contractBusinessDepartment;

  if (!searchCompanyCode || searchCompanyCode.length == 0) {
    searchCompanyCode = ctx.userInfo.userInfo.companyCode;
  }

  if (!searchDepartmentCode || searchDepartmentCode.length == 0) {
    searchDepartmentCode = ctx.userInfo.userInfo.departmentCode;
  }

  // 当前用户所在所有公司
  let allCompanyList = JSON.parse(ctx.userInfo.userInfo.companyList)
    ?.map((item) => item.personCompanyCode)
    .join(',');

  return [
    {
      prop: 'contractDetailCategory',
      name: '制单类型',
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'purchase_contract_detail_category' },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractNo',
      name: '合同编号',
      type: 'input',
      maxlength: 50,
    },
    {
      prop: 'contractName',
      name: '合同名称',
      type: 'input',
      maxlength: 100,
      placeholder: '请输合同名称',
    },
    {
      prop: 'contractType',
      name: '合同类别',
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'serviceContractType' },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractBusinessDepartment',
      name: '业务部门',
      type: 'treeSelect',
      apiUrl: COM_API.LIST_COMPANY_API,
      trigger: 'click',
      // TODO 等待修复
      apiData: {
        tenantCode: ctx.userInfo.userInfo.tenantCode,
        adminFlag: ctx.userInfo.userInfo.adminFlag,
        companyNoList: ctx.query.contractBusinessCompanyNo
          ? [ctx.query.contractBusinessCompanyNo]
          : [],
      },
      multiple: true,
      clearable: false,
      filterData: (data) => {
        const departmentList = ctx.userInfo.userInfo.allDepartmentList.map(
          (v) => v.personDepartmentCode
        );
        const companyList = JSON.parse(ctx.userInfo.userInfo.companyList).map(
          (v) => v.personCompanyCode
        );
        const filterCompanyData = data.filter((v) => companyList.includes(v.id));
        const filterFun = (list) => {
          if (!list) return list;
          if (list.children && list.children.length) {
            return list.map((v) => {
              v.children = filterFun(v.children);
              return v;
            });
          } else return list.filter((v) => departmentList.includes(v.id));
        };
        return filterCompanyData.map((v) => {
          v.children = filterFun(v.children);
          return v;
        });
      },
    },
    {
      prop: 'contractStatus',
      name: '单据状态',
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'contract_status_wm' },
    },
    {
      prop: 'projectInitiationNo',
      name: '项目编号',
      searchType: 'projectListWumao',
      type: 'searchTableSpec',
      isMultiple: true,
      currentValue: ctx.query?.projectInitiationNo ? ctx.query?.projectInitiationNo : null,
      checkRowKeys: [ctx.query.projectInitiationNo ? ctx.query.projectInitiationNo : null],
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        // applyDepartmentNo: ctx.query.contractBusinessDepartment,
        platformtCompany: ctx.query.companyCode,
        // applyDepartmentName: ctx.query.contractBusinessDepartmentName,
        applyCompanyNo: ctx.query.companyCode
          ? ctx.query.companyCode
          : ctx.userInfo.userInfo.companyCode,
        applyCompanyName: ctx.query.companyName
          ? ctx.query.companyName
          : ctx.userInfo.userInfo.companyName,
        platformtCompanyName: ctx.query.companyName
          ? ctx.query.companyName
          : ctx.userInfo.userInfo.companyName,
        // recyclingtCompany: ctx.query.companyCode,
        // recyclingtCompanyName: ctx.query.companyName
        //   ? ctx.query.companyName
        //   : ctx.userInfo.userInfo.companyName,
      },
      changeMethod: 'changeMethod',
    },
    {
      type: 'searchTableSpec',
      name: '供应商名称',
      prop: 'supplier',
      searchType: 'supplier',
      extraData: {
        // departmentCode: searchDepartmentCode, //部门
        companyCode: allCompanyList, //公司
      },
      isNeedMultipleValue: true,
    },
    {
      prop: 'externalContractNo',
      name: '外部合同号',
      type: 'input',
      placeholder: '请输入外部合同号',
    },
    // {
    //   prop: 'isPersonalPartner',
    //   name: '是否个人合作伙伴',
    //   type: 'select',
    //   placeholder: '请选择是否个人合作伙伴',
    //   options: yesNoList,
    // },
    // //不定价
    // {
    //   prop: 'isFixedPrice',
    //   name: '不定价',
    //   type: 'select',
    //   options: yesNoList,
    // },
    // {
    //   prop: 'product',
    //   type: 'searchTableSpec',
    //   name: '商品描述',
    //   searchType: 'product',
    //   isNeedMultipleValue: true,
    //   isMultiple: true,
    //   ref: 'productRef',
    //   extraData: {
    //     detailProductStatus: 'ZT03',
    //     contractCategory: 'purchase',
    //     adminFlag: 2,
    //   },
    //   changeMethod: 'changeMethod',
    // },
    // {
    //   prop: 'isGenerateSales',
    //   name: '是否关联销售合同/协议',
    //   type: 'select',
    //   clearable: true,
    //   options: [
    //     {
    //       label: '是',
    //       value: true,
    //     },
    //     {
    //       label: '否',
    //       value: false,
    //     },
    //   ],
    // },
    // {
    //   prop: 'generateNo',
    //   name: '关联销售合同号',
    //   clearable: true,
    //   type: 'input',
    // },
  ];
};
export const tableColumnListDefault = () => {
  return [
    {
      type: 'checkbox',
      visible: true,
      width: '50',
      fixed: 'left',
    },
    {
      field: 'projectInitiationNo',
      title: '项目编号',
      visible: true,
    },
    {
      field: 'projectName',
      title: '项目名称',
      visible: true,
    },
    {
      field: 'contractNo',
      title: '合同编号',
      visible: true,
    },
    {
      field: 'oaUrl',
      title: '审批详情',
    },
    {
      field: 'contractStatusName',
      title: '单据状态',
      visible: true,
    },
    {
      field: 'contractTypeName',
      title: '合同类别',
      visible: true,
    },
    {
      field: 'contractShippingStatus',
      title: '合同状态',
      visible: true,
    },
    // {
    //   field: 'shipComplete',
    //   title: '是否完全发货',
    //   visible: true,
    // },
    {
      field: 'productQuantity',
      title: '采购数量',
      visible: true,
    },
    {
      field: 'deliverableQuantity',
      title: '剩余可发货数量',
      visible: true,
    },
    {
      field: 'receiptMethodName',
      title: '付款方式',
      visible: true,
    },
    {
      field: 'externalContractNo',
      title: '外部合同号',
      visible: true,
    },
    // {
    //   field: 'tradeTypeName',
    //   title: '贸易类型',
    //   visible: true,
    // },
    {
      field: 'supplierName',
      title: '供应商名称',
      visible: true,
    },
    {
      field: 'businessTypeName',
      title: '业务性质',
      visible: true,
    },
    {
      field: 'contractDetailCategoryName',
      title: '制单类型',
      visible: true,
    },
    // {
    //   field: 'contractNo',
    //   title: '采购号(合同/意向单)',
    //   width: '120',
    //   visible: true,
    // },
    // {
    //   field: 'originalsReceivedBusiness',
    //   title: '正本收集状态',
    //   width: '100',
    //   dictType: 'originalsReceivedBusiness',
    //   visible: true,
    // },
    // {
    //   field: 'originalsReceivedRm',
    //   title: '正本归档状态',
    //   width: '100',
    //   dictType: 'originalsReceivedRm',
    //   visible: true,
    // },
    {
      field: 'contractBusinessCompanyName',
      title: '公司',
      visible: true,
    },
    {
      field: 'contractTotalAmount',
      title: '合同总金额',
      format: 'formatAmountRound',
      visible: true,
      sortable: true,
    },
    {
      field: 'productDesc',
      title: '商品描述',
      visible: true,
      sortable: true,
    },
    // {
    //   //直拨流向
    //   field: 'deliveryPlaceName',
    //   title: '直拨流向',
    //   visible: true,
    // },
    // {
    //   //合同数量
    //   field: 'productQuantity',
    //   title: '合同数量',
    //   format: 'formatQuality',
    //   visible: true,
    //   sortable: true,
    // },
    //合同单价
    {
      field: 'businessContractUnitPrice',
      title: '合同单价',
      visible: true,
      format: 'formatPrice',
      sortable: true,
    },

    {
      field: 'isFixedPriceName',
      title: '不定价',
      visible: true,
    },
    {
      field: 'isPrepayName',
      title: '预付',
      visible: true,
    },
    {
      field: 'contractBusinessDepartmentName',
      title: '业务部门',
      visible: true,
    },
    {
      field: 'contractSalesmanName',
      title: '部门负责人',
      visible: true,
    },
    //操作人
    {
      field: 'contractOperaterName',
      title: '经办人',
      visible: true,
    },
    // {
    //   field: 'receiptConditionName',
    //   title: '付款条件',
    //   visible: true,
    // },
    {
      field: 'lastestPayMoneyDay',
      title: '最晚付款日',
      visible: true,
    },
    {
      field: 'lastestReceiveProductDay',
      title: '最晚收货日',
      visible: true,
    },
    {
      field: 'replyInvoiceDate',
      title: '回票日期',
      visible: true,
    },
    //wumao
    {
      field: 'shipUnsettledQuantity',
      title: '已发货未结算数量',
      visible: true,
    },
    //wumao
    {
      field: 'shipUnsettledAmount',
      title: '已发货未结算金额',
      visible: true,
    },
    {
      field: 'contractCurrencyName',
      title: '货币',
      visible: true,
    },
    {
      field: 'liquidatedDamagesType',
      title: '合同违约金类型',
      visible: true,
    },
    {
      field: 'liquidatedFixedValue',
      title: '违约金固定值',
      visible: true,
    },
    {
      field: 'liquidatedInterestRate',
      title: '违约金日利率',
      visible: true,
    },
    {
      field: 'overShippedPercentage',
      title: '溢装比例',
      visible: true,
    },
    {
      field: 'shortShippedPercentage',
      title: '短装比例',
      visible: true,
    },
    {
      field: 'signDate',
      title: '合同签署日期',
      visible: true,
    },
    {
      field: 'contractValidStart', // TODO
      title: '合同期限',
      visible: true,
      width: 200,
    },
    {
      field: 'contractName',
      title: '合同名称',
      visible: true,
    },
    {
      field: 'pricingRuleName',
      title: '定价模式',
      visible: true,
    },
    // {
    //   field: 'isGenerateSales',
    //   title: '是否关联销售合同/协议',
    //   visible: true,
    // },
    // {
    //   field: 'generateNo',
    //   title: '关联销售合同号',
    //   visible: true,
    // },
    {
      field: 'contractCreateDate',
      title: '制单日期',
      visible: true,
      sortable: true,
    },
  ];
};
